<div class="width-constrained-some">
  <div class="sectionContainer paddedContent containerMargins">
    <app-account-billing-form [mode]="formMode.New"></app-account-billing-form>
  </div>

  <div class="sectionContainer paddedContent containerMargins">
    <div class="flex-container">
      <div style="flex: 6">
        <h3>Primary User</h3>

        <p>
          <input
            type="checkbox"
            (change)="chkUserSameAsContact_clicked()"
            [(ngModel)]="_chkUserSameAsContact"
          />
          Same as primary contact
        </p>

        <div class="column">
          <app-text-input
            [label]="'First name'"
            [groupName]="'Primary User'"
            [required]="true"
            [(ngModel)]="_user.firstName"
          ></app-text-input>
        </div>
        <div class="column">
          <app-text-input
            [label]="'Last name'"
            [groupName]="'Primary User'"
            [required]="true"
            [(ngModel)]="_user.lastName"
          ></app-text-input>
        </div>
        <div class="column">
          <app-text-input
            [label]="'Email address'"
            [groupName]="'Primary User'"
            [style]="'width:300px;'"
            [type]="InputTextModesEnum.Email"
            [required]="true"
            [(ngModel)]="_user.emailAddress"
          ></app-text-input>
        </div>
      </div>
    </div>
  </div>

  <div class="flexBoxPrimary">
    <input
      type="button"
      value="Cancel"
      class="button_primary button_var_2"
      (click)="btnCancel_click()"
      (keydown.escape)="btnCancel_click()"
    />
    <input
      type="button"
      value="Save"
      class="button_primary button_var_2"
      (click)="btnSave_click()"
      (keydown.enter)="btnSave_click()"
    />
  </div>
</div>
